import React, {Fragment, useRef} from 'react';
import MyModal from "./Modal";
import {useTranslation} from "react-i18next";
import {Button, Flex, Form, message} from "antd";
import FormItems from "./FormItems";
import dayjs from "dayjs";
import useSWRMutation from "swr/mutation";
import {income_act_period_reload} from "../api/api";
import {afterRequest, postRequest} from "../api/config";

const PeriodReload = () => {

    const ref = useRef();
    const {t} = useTranslation();
    const [form] = Form.useForm();
    const {trigger, isMutating} = useSWRMutation(income_act_period_reload, postRequest);

    const onSubmit = (formData) => {

        const {date} = formData;
        const start =  dayjs(date[0]).format("YYYY-MM-DD");
        const end = dayjs(date[1]).format("YYYY-MM-DD");

        afterRequest(
            trigger,
            {data: {start, end}},
            () => {
                ref?.current?.closeModal();
                message?.open({
                    content: t('successfully'),
                    key: 'updatable',
                    type: 'success'
                })
            })
    }

    const onCancel = () => {
        form.resetFields();
    }

    const fields = [
        {
            name: "date",
            type: "rangePicker",
            allowClear: true,
            format: "DD.MM.YYYY",
            required: true,
        }
    ]

    return (
        <Fragment>
            <MyModal afterClose={onCancel} modalTitle={t('Обновить за выбранный период')} button={false} ref={ref}>
                <Form form={form}  layout={"vertical"} onFinish={onSubmit}>

                    <FormItems
                        formItems={fields}
                    />

                    <Flex justify={'flex-end'}>
                        <Button type="primary" htmlType="submit" loading={isMutating}>
                            {t("Подвердить")}
                        </Button>
                    </Flex>
                </Form>
            </MyModal>
            <Button size={"large"}
                    onClick={() => ref?.current?.openModal()}>{t('Обновить за выбранный период')}</Button>

        </Fragment>
    );
};

export default PeriodReload;